/*
* ВЦХТ Конфигурация
* extends global app configuration - config.js
*/
import appConfig from '@/config';

const { ROLES } = appConfig;

const authenticatedInstructions = new Map();
// authenticatedInstructions.set([ROLES.department], 'DepartamentVcht');
// authenticatedInstructions.set([ROLES.operator], 'OperatorVcht');
authenticatedInstructions.set([ROLES.member, ROLES.certificate], 'MemberVcht');
authenticatedInstructions.set([ROLES.organization], 'OrganizationVcht');

export default {
  ...appConfig,

  USER_AGREEMENT: '/agreements/user-agreement-vcht',
  authenticatedInstructions,
};
